export const getLang = (systemLanguage: string) => {
  let retLangData;
  switch (systemLanguage) {
    case 'ja':
      retLangData = require('../assets/jsons/lang/ja.json');
      break;
    case 'en':
      retLangData = require('../assets/jsons/lang/en.json');
      break;
    case 'vn':
      retLangData = require('../assets/jsons/lang/vn.json');
      break;
    default:
      retLangData = require('../assets/jsons/lang/en.json');
  }
  return retLangData;
};
